import { FreshdeskFaqsService } from './freshdesk-faqs.service';

export default angular
  .module('ng1-freshdesk-faqs', [])
  .service('freshdeskFaqsService', FreshdeskFaqsService)
  .name;
